export const ERROR_TYPES = {
  NOT_FOUND: "404",
  FORBIDDEN: "403",
  MOBILE: "mobile",
};
